export const currencyLocales: Record<
  string,
  { locale: string; fractionDigits: number }
> = {
  USD: {
    locale: "en-US",
    fractionDigits: 2,
  },
  CAD: {
    locale: "en-CA",
    fractionDigits: 2,
  },
  INR: {
    locale: "hi-IN",
    fractionDigits: 2,
  },
  CNY: {
    locale: "zh-CN",
    fractionDigits: 2,
  },
  AUD: {
    locale: "en-AU",
    fractionDigits: 2,
  },
  RUB: {
    locale: "ru-RU",
    fractionDigits: 2,
  },
  HKD: {
    locale: "zh-SD",
    fractionDigits: 2,
  },
  EUR: {
    locale: "de-DE",
    fractionDigits: 2,
  },
  JPY: {
    locale: "ja-JP",
    fractionDigits: 0,
  },
  NZD: {
    locale: "en-NZ",
    fractionDigits: 2,
  },
  SGD: {
    locale: "zh-SG",
    fractionDigits: 2,
  },
  SEK: {
    locale: "sv-SE",
    fractionDigits: 2,
  },
  GBP: {
    locale: "en-UK",
    fractionDigits: 2,
  },
  MXN: {
    locale: "es-MX",
    fractionDigits: 2,
  },
  DKK: {
    locale: "da-DK",
    fractionDigits: 2,
  },
  KRW: {
    locale: "ko-KR",
    fractionDigits: 2,
  },
  BRL: {
    locale: "pt-BR",
    fractionDigits: 2,
  },
}
